import "./journal_posts.css";
